import { Segment } from '@/components/inventory-toolbar';
import { useInventoryId } from '@/hooks/use-inventory-id';
import { useScenarioId } from '@/hooks/use-scenario-id';
import { useGetScenarioQuery } from '@/api/scenarios';
import { scenarioPath } from '@/links';

// The breadcrumb segment for an open scenario (the detail view). Mirrors
// `toolbar-scenario` (the pathway segment). Creating a scenario lives inline on
// the list page (`pages/scenarios`, mirroring suit's `pages/plan`), so there is
// no list-toolbar button.
const ToolbarScenario = () => {
  const inventoryId = useInventoryId();
  const scenarioId = useScenarioId();
  const { data: scenario, isSuccess } = useGetScenarioQuery(scenarioId);

  return isSuccess ? (
    <Segment to={scenarioPath(inventoryId, scenarioId)} label={scenario.name} />
  ) : null;
};

export { ToolbarScenario };
